import { ListSubheader, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { Country, State } from "models/Geography";
import { groupBy } from "lodash";
import { useAuthContext } from "AuthContextWrapper";
import { useEffect, useState } from "react";

export interface IProps {
  disabled?: boolean,
  countryId?: string,
  label?: string,
  renderParams?: any,
  readOnly?: boolean,
  overrideOptions?: JSX.Element[],
  onCountryIdChange: (id:string) => void,
  size?:"small"|"medium",
}

export function SelectCountry(props:IProps):JSX.Element {
  const { countries } = useAuthContext()
  const [ myOptions, setMyOptions ] = useState<JSX.Element[]>(props.overrideOptions as JSX.Element[])

  useEffect(() => {
    if(!countries) {
      return
    }

    setMyOptions(getEstateLocationOptions(countries))
  }, [countries])


  return <Select
    fullWidth
    readOnly={props.readOnly}
    name="state"
    disabled={props.disabled}
    value={props.countryId?.toString()}
    label={props.label || ""}
    size={props.size || "medium"}
    onChange={(e:SelectChangeEvent) => {
      e.stopPropagation()
      e.preventDefault()
      if(e.target.value) {
        props.onCountryIdChange(e.target.value)
      }
    }}
    {...props.renderParams}
  >
    {myOptions}
  </Select>
}


function getEstateLocationOptions(countries: Country[]):JSX.Element[] {
  return countries.map(c => <MenuItem key={c.id} value={c.id}>
    {c.fullName}
  </MenuItem>);
}